import Immutable from "seamless-immutable";
import { layoutState } from "./layout.types";

const DDEFAULT_LAYOUT_STATE: layoutState = {
  direction: "ltr",
};
export default Immutable(DDEFAULT_LAYOUT_STATE);
